// removed by extract-text-webpack-plugin
module.exports = {"link":"style__link___a8h4O","link--disabled":"style__link--disabled___2Cx6N"};


//////////////////
// WEBPACK FOOTER
// ./components/ButtonLink/style.scss
// module id = 1148
// module chunks = 0